import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PersonInfoVM} from "../../models/PersonInfoVM.model";
import * as moment from 'jalali-moment';
import {CompanyCustomerVM} from "../../models/CompanyCustomerVM.model";

@Component({
  selector: 'rw-customer-intake-data',
  template: require('./customer-intake-data.component.html'),
  styles: [require('./customer-intake-data.style.css')]
  // providers: [CategoryService]

})

export class CustomerIntakeDataComponent implements OnInit {
  @Input() companyCustomer: CompanyCustomerVM;
  @Input() isUpdateMode: boolean = false ;

  dpConfig;
  canSave = false;
  dateObject: any = moment();

  constructor() {
  }

  ngOnInit(): void {
    this.dpConfig = {
      drop: 'down'
    }



    // this.makeBirthDate();
  }

  collectFormData() {
    let parent=this;
    let isFormValid=true;
    // this.companyCustomer.fields.forEach(function(f){
    //
    //   let isValid=parent.checkIsFormValid(f);
    //   if(!isValid)
    //     isFormValid=false;
    //
    //
    // })

    // this.intakeFormChange.emit(this.intakeForm);
    return isFormValid;
  }

  dateChanged() {
    // this.personInfo.birthDate = new Date(this.dateObject).toISOString()
  }

  makeBirthDate() {
    // let year = new Date(this.personInfo.birthDate).getFullYear();
    // let month = new Date(this.personInfo.birthDate).getMonth() + 1;
    // let date = new Date(this.personInfo.birthDate).getDate();
    // let gregorianYMD = year + '/' + month + '/' + date;
    // let jalali = moment(gregorianYMD, 'YYYY/MM/DD').locale('fa').format('jYYYY-jMM-jDD');
    // this.dateObject = moment(jalali, 'jYYYY,jMM,jDD');
  }

  necessaryFieldsCheck() {
    try {
      if ((this.companyCustomer.customer.personalInfo.fisrtName != '' && this.companyCustomer.customer.personalInfo.fisrtName != undefined) &&
        (this.companyCustomer.customer.personalInfo.lastName != '' && this.companyCustomer.customer.personalInfo.lastName != undefined)) {
        this.canSave = true;
      } else {
        this.canSave = false;
      }
    } catch (ex) {
      // nothing
    }
  }

  showField(f){

    if(this.isUpdateMode)
      return true;
    if(!this.isUpdateMode && !f.value)
      return true;

    return false;
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/customer-intake-data/customer-intake-data.component.ts